import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getPayRateByPositionCsv } from 'api/pulse/payRateByPosition'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function usePayRateByPositionDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_pay_rate_by_position', {
        filters: query,
      })
      const data = await getPayRateByPositionCsv(query)
      fileDownload(data, 'pay_rate_by_position.csv')
    },
  })
}
